export default [
    {
        path: '/admin/academic/certificates',
        name: 'certificate',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/certificate/index.vue')
    },
]
